import { useEffect } from "react";
import { absoluteUrl, businessSchema } from "../utils/schema";
type SeoProps = {
  title: string;
  description: string;
  path: string;
  schema: Record<string, unknown>[];
};
export function Seo({
  title,
  description,
  path,
  schema
}: SeoProps) {
  const schemaJson = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": [businessSchema(), ...schema]
  });
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = "en-AU";
    let descriptionElement = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!descriptionElement) {
      descriptionElement = document.createElement("meta");
      descriptionElement.name = "description";
      document.head.appendChild(descriptionElement);
    }
    descriptionElement.content = description;
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = absoluteUrl(path);
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.seo = "phac-structured-data";
    script.textContent = schemaJson;
    document.head.appendChild(script);
    return () => script.remove();
  }, [title, description, path, schemaJson]);
  return null;
}